/**
 * Utility functions for tenant-based routing and redirection
 */

export type Tenant = 'main' | 'partnership';

/**
 * Get the user's tenant from localStorage
 */
export const getUserTenant = (): Tenant => {
  const tenant = localStorage.getItem('user_tenant');
  return (tenant as Tenant) || 'main';
};

/**
 * Get the appropriate main page URL based on tenant
 * Both tenants now use the same routes, just different databases
 */
export const getMainPageUrl = (tenant: Tenant): string => {
  // Both tenants use the same main page
  return '/';
};

/**
 * Check if the current path belongs to the user's tenant
 * Both tenants can now access all routes (database separation handles security)
 */
export const isPathForTenant = (path: string, tenant: Tenant): boolean => {
  // Both tenants can access all routes - database separation provides security
  // Only block partnership users from accessing /partnership/* routes (legacy)
  if (tenant === 'partnership' && path.startsWith('/partnership')) {
    return false; // Redirect partnership users away from old partnership routes
  }
  return true;
};

/**
 * Get the tenant from a URL path
 */
export const getTenantFromPath = (path: string): Tenant => {
  if (path.startsWith('/partnership')) {
    return 'partnership';
  }
  return 'main';
};
